import { useParsedSearchParams } from "@fidelix/fx-miranda";
import { SidePanelLayout } from "../common/page-layout";
import { DeviceErrorBanner } from "../device/device-error-banner";
import { useDeviceQuery } from "../device/device.queries";
import { GraphicTree } from "../tree/graphic-tree";
import { GraphicsView } from "./graphics-view";

export function GraphicsRoute() {
  const { parsedParams } = useParsedSearchParams({
    deviceId: { type: "number", defaultValue: undefined },
    treeKey: { type: "string", defaultValue: "default" },
  });
  const { data: device } = useDeviceQuery(parsedParams.deviceId, {
    enabled: !!parsedParams.deviceId,
  });
  return (
    <>
      <DeviceErrorBanner key={device?.id} device={device} />
      <SidePanelLayout showBorder isScrollable isCollapsible hasTree>
        <GraphicTree key={parsedParams.treeKey} />
      </SidePanelLayout>
      <GraphicsView />
    </>
  );
}
